import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
    selector: '[portValidate]',
    providers: [{ provide: NG_VALIDATORS, useExisting: PortValidateDirective, multi: true }]
})
export class PortValidateDirective implements Validator {
    validate(control: AbstractControl): ValidationErrors {
        if (control.value && control.value !== null && control.value !== undefined) {
            const isValid = 0 <= control.value && control.value <= 65535;
            if (!isValid) {
                return { ['portInvalid']: true }; // return object if the validation is not passed.
            }
        }
        return null; // return null if validation is passed.
    }
}
